export default __webpack_public_path__ + "static/media/Anthe_banner_app.0a58c76a.png";